export enum DeviceCategory {
  PC = "PC",
  SP = "WEB-SP",
}

export type DeviceName = keyof typeof DeviceCategory;
